<template>
    <div class="mt-2" :class="alertClass" v-if="mostraMessaggio">
        <font-awesome-icon :icon="alertIcon" :spin="alertIconSpin" />&nbsp; {{ProcessaTestoMessaggio()}}
    </div>
</template>

<script>


export default {
 name: "MessaggioStandard",   
 props: {
    mostraMessaggio: Boolean,
    alertMessaggio: [],
    alertClass: String,     
    alertIcon: String,
    alertIconSpin: Boolean,

 },
 data: function () {
    return {
      
    }
 },
 methods: {
    ProcessaTestoMessaggio() {
    

        let msg = '';
        for(let i=0; i<this.alertMessaggio.length; i++) {
            msg += this.alertMessaggio[i] + " ";
        }
        return msg;
    }    
 },
 watch: {
   
 },
 mounted: function() {
    
    
 }
 
}

</script>

<style scoped>


</style>
